import React from 'react';
import classNames from 'classnames';
import { isIOSSafari } from 'Helpers/UtilsWithoutLodash';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';


const styles = () => ({
  spacer: {
    height: 0,
    display: 'none',
  },
  spacerIOS: {
    height: '28px',
    display: 'block',
  },
  content: {},
});

const BottomSpacer = ({
  classes,
  className,
}) => (
  <div
    className={classNames(className, classes.spacer, {
      [classes.spacerIOS]: isIOSSafari(),
    })}
  />
);
BottomSpacer.defaultProps = {
  className: '',
};

BottomSpacer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomSpacer);
